import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Убираем LanguageDetector, так как он конфликтует с нашим контекстом
// import LanguageDetector from 'i18next-browser-languagedetector';

// Импорт переводов
import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';
import esTranslations from './locales/es.json';

const resources = {
  en: {
    translation: enTranslations
  },
  ru: {
    translation: ruTranslations
  },
  es: {
    translation: esTranslations
  }
};

i18n
  // Убираем LanguageDetector
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    lng: 'en', // Устанавливаем язык по умолчанию

    interpolation: {
      escapeValue: false, // React уже экранирует значения
    },

    // Убираем автоматическое определение языка
    // detection: {
    //   order: ['localStorage', 'navigator', 'htmlTag'],
    //   caches: ['localStorage'],
    //   lookupLocalStorage: 'i18nextLng',
    // },

    react: {
      useSuspense: false,
    },
  });

export default i18n; 